import axios from 'axios';
import game from '../Game/GameInstance';
import Room from '../Models/Room';
import PersonIndicator from '../Models/PersonIndicator';

let nullable = (n, def) => {
  if (typeof def === 'undefined') {
    def = '';
  }
  return n ? n : def;
};


export default class RoomUpdater {

  constructor(apiBase) {

    this.endpoint = apiBase + 'room';
    this.paused = true;
    this.timeout = null;

    this.notificationAlreadyShowing = false;

  }

  pause() {

    if (!this.paused) {

      this.paused = true;
      clearTimeout(this.timeout);
      return;

    }

    console.warn('Cannot pause RoomUpdater: already paused!');

  }

  resume() {

    if (this.paused) {

      this.paused = false;
      this.scheduleNextStep()
      return;
    }

    console.warn('Cannot resume RoomUpdater: already running!');

  }

  scheduleNextStep(){
    if(this.paused === false){
      this.update().finally(() => {
        this.timeout = setTimeout(() => this.scheduleNextStep(), 10000);
      })
    }
  }

  firstRun() {

    return new Promise((resolve, reject) => {

      RequestHelperInstance.get(this.endpoint + '&cache=false')
        .then(response => {
          // check if game has been paused before response was received
          if(game.paused) return;

          response.forEach((roomData, index) => {

            if (game.rooms.length > 10000) {
              return;
            }

            let room = new Room(roomData);

            room.game = game;
            room.index = index;

            // console.log('pushing room', game.rooms.length);
            game.rooms.push(room);
            game.layers.ground.push(room);

            let personIndicator = new PersonIndicator(32, {});

            personIndicator.hide();
            room.personIndicator = personIndicator;

            game.layers.people.push(personIndicator);

          });

          this.afterFirstRun();
          resolve();

        });

    });



  }

  afterFirstRun()
  {

    game.positionRooms();
    game.buildWall();

    game.pathGenerator.generate();

    let doorPoint = game.pathGenerator.findSouthernMostPoint();

    game.entrancePoint = { x : doorPoint.x, y : doorPoint.y + 200, id : game.points.length };
    game.points.push(game.entrancePoint);
    game.paths.push({ a : doorPoint, b : game.entrancePoint });

    game.shortestPathGenerator.index();

    if (game.wall) {
      game.wall.opening = doorPoint.x;
    }


    this.resume();

  }

  update() {


    return RequestHelperInstance.get(this.endpoint + '&cache=true')
      .then(response => {
        // check if game has been paused before response was received
        if(game.paused) return;

        response.forEach((roomData, index) => {
          const room = game.rooms.find((value) => {
            return roomData.id === value.data.id;
          });

          if (room) {
            room.set('name', nullable(roomData.name));
            room.set('current_event', nullable(roomData.current_event));
            room.set('current_event_time', nullable(roomData.current_event_time));


            if (this.needsSpeakerUpdate(nullable(roomData.speakers, []), room.speakers)) {
              room.setSpeakers(nullable(roomData.speakers, []));
              room.needsRendering = true;
            }

            return;
          }

          this.mapHasUpdate(roomData);
        });

      });
  }

  mapHasUpdate(roomData) {
    if (this.notificationAlreadyShowing) {
      return;
    }

    const links = {
      room: this.endpoint,
      person: game.personUpdater.endpoint
    };

    window.dispatchEvent(
        new CustomEvent(
            'update-interactive-map',
            {
              detail: {
                links,
                isNetworkingTable: roomData.mode === 'table'
              }
            }
        )
    )

    this.notificationAlreadyShowing = true;
  }


  needsSpeakerUpdate(apiSpeakers, roomSpeakers)
  {

    if (apiSpeakers.length !== roomSpeakers.length) {
      return true;
    }

    let i = apiSpeakers.length;
    while (i--) {

      let compare = [
        'first_name',
        'last_name',
        'avatar_url',
      ];

      for (let j = 0; j < compare.length; j++) {
        if (apiSpeakers[i][compare[j]] !== roomSpeakers[compare[j]]) {
          return true;
        }
      }
    }

    return false;

  }

}
